import { render, staticRenderFns } from "./input-quantite.vue?vue&type=template&id=32fd2385&scoped=true&"
import script from "./input-quantite.vue?vue&type=script&lang=js&"
export * from "./input-quantite.vue?vue&type=script&lang=js&"
import style0 from "./input-quantite.vue?vue&type=style&index=0&id=32fd2385&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fd2385",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VCard,VIcon,VInput})
